(function (root, factory) {
    const navigation = factory();

    if (typeof module === 'object' && module.exports) {
        module.exports = navigation;
    }

    root.QawafilPreviewNavigation = navigation;

    if (root.QawafilStore && root.QawafilStore.previewCapability) {
        navigation.start(document, root.QawafilStore.previewCapability, root.location.href);
    }
}(typeof window !== 'undefined' ? window : globalThis, function () {
    const ENTRY_QUERY_KEYS = ['_pth', 'thd', 'draft', '_sd', 'sid', 'alt'];

    function addCapabilityToUrl(url, capability) {
        if (!capability) return url;

        ENTRY_QUERY_KEYS.forEach(key => url.searchParams.delete(key));
        url.searchParams.set('pv', capability);

        return url;
    }

    function previewHref(href, capability, currentHref) {
        if (!href || href.startsWith('#') || /^(javascript|mailto|tel):/i.test(href)) {
            return href;
        }

        try {
            const currentUrl = new URL(currentHref);
            const targetUrl = new URL(href, currentUrl);

            return targetUrl.origin === currentUrl.origin
                ? addCapabilityToUrl(targetUrl, capability).href
                : href;
        } catch (error) {
            return href;
        }
    }

    function decorateLinks(container, capability, currentHref) {
        if (!container || !capability) return;

        container.querySelectorAll('a[href]:not([data-preview-exit]):not([download])').forEach(link => {
            link.href = previewHref(link.getAttribute('href'), capability, currentHref);
        });
    }

    function preserveGetForm(form, capability, currentHref) {
        if (!form || !capability) return;

        try {
            // Read the ATTRIBUTES, never the `form.method` / `form.action` properties: a control named
            // "method" or "action" shadows them with an element, and `.toLowerCase()` on that throws.
            // The throw used to escape this function and abort the caller's loop — which left the submit
            // listener and the MutationObserver uninstalled, so fragment-inserted links silently lost `pv`.
            if ((form.getAttribute('method') || 'get').toLowerCase() !== 'get') return;

            const currentUrl = new URL(currentHref);
            const actionUrl = new URL(form.getAttribute('action') || currentHref, currentUrl);
            if (actionUrl.origin !== currentUrl.origin) return;

            let field = form.querySelector('input[name="pv"]');
            if (!field) {
                field = document.createElement('input');
                field.type = 'hidden';
                field.name = 'pv';
                form.appendChild(field);
            }
            field.value = capability;
        } catch (error) {
            // Invalid custom form actions should keep their original browser behavior.
        }
    }

    function start(documentRoot, capability, currentHref) {
        if (!documentRoot || !capability) return;

        decorateLinks(documentRoot, capability, currentHref);
        documentRoot.querySelectorAll('form').forEach(form => preserveGetForm(form, capability, currentHref));
        documentRoot.addEventListener('submit', event => preserveGetForm(event.target, capability, currentHref), true);

        if (typeof MutationObserver !== 'undefined') {
            new MutationObserver(mutations => {
                mutations.forEach(mutation => mutation.addedNodes.forEach(node => {
                    if (node.nodeType !== 1) return;

                    if (node.matches && node.matches('a[href]')) {
                        const href = previewHref(node.getAttribute('href'), capability, currentHref);
                        if (!node.matches('[data-preview-exit], [download]')) node.href = href;
                    }
                    decorateLinks(node, capability, currentHref);
                    if (node.matches && node.matches('form')) preserveGetForm(node, capability, currentHref);
                    if (node.querySelectorAll) {
                        node.querySelectorAll('form').forEach(form => preserveGetForm(form, capability, currentHref));
                    }
                }));
            }).observe(documentRoot.documentElement || documentRoot, {childList: true, subtree: true});
        }
    }

    return {addCapabilityToUrl, previewHref, decorateLinks, preserveGetForm, start};
}));
